const NEW_RELEASE_WINDOW_DAYS = 2;
const BESTSELLER_MIN_RATING = 4.5;
const BESTSELLER_MIN_REVIEWS = 1000;
const TRENDING_MIN_REVIEWS = 900;

const daysSince = (date) => {
  if (!date) return Infinity;
  const parsed = new Date(date).getTime();
  if (Number.isNaN(parsed)) return Infinity;
  return (Date.now() - parsed) / (1000 * 60 * 60 * 24);
};

// Computes the badge chip from live signals (price, publish date, rating, reviews)
// instead of trusting a stored label that goes stale the moment those signals change.
export function getBookBadge(book) {
  if (!book) return null;

  if (book.price === 0) return 'Free';
  if (book.badge === "Editor's Pick") return "Editor's Pick";

  const age = daysSince(book.published);
  if (age <= NEW_RELEASE_WINDOW_DAYS) return 'New Release';

  if (book.rating >= BESTSELLER_MIN_RATING && book.reviewsCount >= BESTSELLER_MIN_REVIEWS) {
    return 'Bestseller';
  }

  if (book.reviewsCount > TRENDING_MIN_REVIEWS) return 'Trending';

  return null;
}
